import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './auth/AuthContext';
import ProtectedRoute from './auth/ProtectedRoute';

import PublicLayout from './public-site/Header';
import Home from './public-site/Home';
import PrivacyPolicy from './public-site/PrivacyPolicy';
import Refund from './public-site/Refund';
import Terms from './public-site/Terms';

import StudentLogin from './student/Login';
import StudentRegister from './student/Register';
import StudentPassword from './student/Password';
import StudentLayout from './student/Layout';
import StudentDashboard from './student/Dashboard';
import StudentTeachers from './student/Teachers';
import StudentTeacherDetail from './student/TeacherDetail';
import StudentWallet from './student/Wallet';
import StudentBookings from './student/Bookings';
import StudentClasses from './student/Classes';

import TeacherLogin from './teacher/Login';
import TeacherRegister from './teacher/Register';
import TeacherPassword from './teacher/Password';
import TeacherLayout from './teacher/Layout';
import TeacherDashboard from './teacher/Dashboard';
import TeacherProfile from './teacher/Profile';
import TeacherDemos from './teacher/Demos';
import TeacherStudents from './teacher/Students';
import TeacherEarnings from './teacher/Earnings';

import AdminLogin from './admin/Login';
import AdminPassword from './admin/Password';
import AdminLayout from './admin/Layout';
import AdminDashboard from './admin/Dashboard';
import AdminManageTeachers from './admin/ManageTeachers';
import AdminManageStudents from './admin/ManageStudents';
import AdminManageBookings from './admin/ManageBookings';
import AdminManageDemos from './admin/ManageDemos';
import AdminManagePayments from './admin/ManagePayments';
import AdminManageAttendance from './admin/ManageAttendance';
import AdminSettlements from './admin/Settlements';
import AdminSettings from './admin/Settings';
import AdminSubjects from './admin/Subjects';
import AdminDemoRequests from './admin/DemoRequests';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PublicLayout />}>
            <Route index element={<Home />} />
            <Route path="privacy" element={<PrivacyPolicy />} />
            <Route path="refund" element={<Refund />} />
            <Route path="terms" element={<Terms />} />
          </Route>

          <Route path="/student/login"          element={<StudentLogin />} />
          <Route path="/student/register"       element={<StudentRegister />} />
          <Route path="/student/forgot-password" element={<StudentPassword />} />
          <Route path="/student" element={<ProtectedRoute role="student"><StudentLayout /></ProtectedRoute>}>
            <Route index              element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard"   element={<StudentDashboard />} />
            <Route path="teachers"    element={<StudentTeachers />} />
            <Route path="teachers/:id" element={<StudentTeacherDetail />} />
            <Route path="wallet"      element={<StudentWallet />} />
            <Route path="bookings"    element={<StudentBookings />} />
            <Route path="classes"     element={<StudentClasses />} />
          </Route>

          <Route path="/teacher/login"          element={<TeacherLogin />} />
          <Route path="/teacher/register"       element={<TeacherRegister />} />
          <Route path="/teacher/forgot-password" element={<TeacherPassword />} />
          <Route path="/teacher" element={<ProtectedRoute role="teacher"><TeacherLayout /></ProtectedRoute>}>
            <Route index            element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<TeacherDashboard />} />
            <Route path="profile"   element={<TeacherProfile />} />
            <Route path="demos"     element={<TeacherDemos />} />
            <Route path="students"  element={<TeacherStudents />} />
            <Route path="earnings"  element={<TeacherEarnings />} />
          </Route>

          <Route path="/admin/login"           element={<AdminLogin />} />
          <Route path="/admin/forgot-password" element={<AdminPassword />} />
          <Route path="/admin" element={<ProtectedRoute role="admin"><AdminLayout /></ProtectedRoute>}>
            <Route index              element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard"   element={<AdminDashboard />} />
            <Route path="teachers"    element={<AdminManageTeachers />} />
            <Route path="students"    element={<AdminManageStudents />} />
            <Route path="bookings"    element={<AdminManageBookings />} />
            <Route path="demos"       element={<AdminManageDemos />} />
            <Route path="payments"    element={<AdminManagePayments />} />
            <Route path="attendance"  element={<AdminManageAttendance />} />
            <Route path="settlements" element={<AdminSettlements />} />
            <Route path="subjects"      element={<AdminSubjects />} />
            <Route path="demo-requests" element={<AdminDemoRequests />} />
            <Route path="settings"      element={<AdminSettings />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
